import { useMatch } from 'react-router';
import { E_APP_ROUTES } from '@router/enums';

import yocLogo from '@assets/yoc-white-logo.svg';
import { E_THEME } from '@common/configs';
import { useIsMobile } from '@common/hooks';
import ArrowButton from '@components/Button/ArrowButton';
import LanguageSwitch from '@components/LanguageSwitch';
import { useMobileView } from '@components/Sidebar/hooks';

import MobileMenu from './MobileMenu';

import style from './styles.module.scss';

const Header = () => {
  const isMobile = useIsMobile();
  const isReportPage = !!useMatch(E_APP_ROUTES.REPORT);
  const { showMobileSidebar, closeMobileSidebar } = useMobileView();

  return (
    <header className={style.header}>
      <div aria-label="Deal Vault Logo">
        <strong className={style.logo}>
          {!showMobileSidebar && isMobile ? (
            <ArrowButton onClick={closeMobileSidebar} />
          ) : (
            <img
              src={yocLogo}
              alt="Deal Vault Logo"
            />
          )}
          DEAL VAULT&reg;
        </strong>
      </div>
      {isMobile ? isReportPage && <MobileMenu /> : <LanguageSwitch theme={E_THEME.DARK} />}
    </header>
  );
};

export default Header;
